import {
  AREA_PINS_SUCCESS
} from '../actions/pins'

import {
  AREA_ACTIVITIES_SUCCESS
} from '../actions/area-activities'

import {
  AREA_WORK_TRACKERS_SUCCESS
} from '../actions/work-trackers'

import {
  PIN_COMMENT_SUCCESS,
  UNPIN_COMMENT_SUCCESS,
  CREATE_COMMENT_SUCCESS
} from '../actions/comments'

import {
  SET_CURRENT_SEARCH,
  SET_CURRENT_FILTER,
  RESET_CURRENT_FILTER
} from '../actions/areas'

import forEach from 'lodash/forEach'

export default function (state = {}, action) {
  switch (action.type) {
    case AREA_PINS_SUCCESS:
      return {
        ...state,
        [action.payload.areaId]: {
          ...state[action.payload.areaId],
          pins: action.payload.result
        }
      }

    case AREA_ACTIVITIES_SUCCESS:
      return {
        ...state,
        [action.payload.areaId]: {
          ...state[action.payload.areaId],
          activities: action.payload.result
        }
      }

    case AREA_WORK_TRACKERS_SUCCESS:
      return {
        ...state,
        [action.payload.areaId]: {
          ...state[action.payload.areaId],
          workTrackers: action.payload.result,
          finishedLoadingWorkTrackers: true,
        }
      }

    case CREATE_COMMENT_SUCCESS:
    case PIN_COMMENT_SUCCESS:
      return pinCommentInAreas(state, action.payload.commentId, action.payload.areaId)

    case UNPIN_COMMENT_SUCCESS:
      return unpinCommentInAreas(state, action.payload.commentId)

    case SET_CURRENT_SEARCH:
      return {...state, currentSearch: action.search}

    case SET_CURRENT_FILTER:
      return {...state, currentFilter: action.areaId}

    case RESET_CURRENT_FILTER:
      return {...state, currentFilter: null}

    default:
      return state
  }
}

function pinCommentInAreas (areas, activityId, areaId) {
  const commentId = activityId.replace(/\D/g, '')

  if (areaId) {
    areas = {
      ...areas,
      [areaId]: {
        ...areas[areaId],
        pinnedComment: commentId
      }
    }
  } else {
    forEach(areas, (area, id) => {
      if (area.activities && area.activities.includes(activityId)) {
        areas = {
          ...areas,
          [id]: {
            ...areas[id],
            pinnedComment: commentId
          }
        }
      }
    })
  }


  return areas
}

function unpinCommentInAreas (areas, activityId) {
  forEach(areas, (area, id) => {
    if (area.activities && area.activities.includes(activityId)) {
      areas = {
        ...areas,
        [id]: {
          ...areas[id],
          pinnedComment: null
        }
      }
    }
  })

  return areas
}



// WEBPACK FOOTER //
// ./src/reducers/areas.js